import styles from './create-new-level-dialog.module.scss';
import { Col, Row } from 'reactstrap';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { makeCourseRequest } from 'libs/webkua-lib/src/lib/requestUtils';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CreateNewLevelDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void
}

export function CreateNewLevelDialog(props: CreateNewLevelDialogProps) {
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);

  const [loading, setLoading] = useState<boolean>(false);
  const [level, setLevel] = useState<string>("");

  const handleLevelChange = (event: any) => setLevel(event.target.value);

  const missingFields = (): boolean => {
    const requiredFieldsFilled =
      level;
    return requiredFieldsFilled ? false : true;
  };

  const handleAddLevel = () => {
    setLoading(true);
    const body = {
      name: level
    }
    makeCourseRequest(`resource/level/upsert`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('createNewLevel.addedLevelToList'), type: "info", });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('createNewLevel.couldNotAddLevelToList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('standard.newLevel')}
      </DialogTitle>
      <DialogContent>
        <Row>
          <Col xl={12}>
            <div className='mb-3'>
              <TextField
                label={<span>{t('standard.level')} &#42;</span>}
                name='level'
                fullWidth
                sx={{ minWidth: 300 }}
                value={level || ''}
                onChange={handleLevelChange}
              />
            </div>
          </Col>
        </Row>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          onClick={handleAddLevel}
          disabled={loading || missingFields()}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('createNewLevel.addLevel')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default CreateNewLevelDialog;
